import TransactionDetail from './TransactionDetail';
import TransactionList from './TransactionList';

const routes = [
  {
    path: '',
    element: <TransactionList />,
  },
  {
    path: ':hash',
    element: <TransactionDetail />,
  },
];

export default routes;
export { TransactionDetail, TransactionList };
